import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AdmihairBaseComponent } from '../../../admihair-base.component';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { Table } from 'primeng/table';
import { ConfirmationService } from 'primeng/api';
import { Psp } from 'src/app/admihair/api/dto/psp';
import { PspConfiguracaoEmpresa } from 'src/app/admihair/api/dto/psp-configuracao-empresa';
import { PspConfiguracaoEmpresaService } from 'src/app/admihair/service/psp-configuracao.service';

@Component({
  selector: 'app-configuracao-pix-listar',
  templateUrl: './configuracao-pix-listar.component.html',
  styleUrls: ['./configuracao-pix-listar.component.scss']
})
export class ConfiguracaoPixListarComponent extends AdmihairBaseComponent implements OnInit {

  @ViewChild("filter") filter!: ElementRef;
  loading: boolean = false;

  listaPspsConfigurados: PspConfiguracaoEmpresa[] = [];

  constructor(
    private pspConfiguracaoEmpresaService: PspConfiguracaoEmpresaService,
    private confirmationService: ConfirmationService,
    erroService: ErroService,
    storageService: UtilStorageService,) {
    super(erroService, storageService);
  }

  ngOnInit(): void {
    this.permissaoListar = this.verificarPermissao("PERM_CONFIGURACAO_PIX");
    this.listar();
  }

  listar() {
    this.loading = true;
    this.pspConfiguracaoEmpresaService.listarPorEmpresa(this.getEmpresa().id).subscribe({
      next: (data: PspConfiguracaoEmpresa[]) => {
        this.listaPspsConfigurados = data
        this.loading = false;
      },
      error: (err: any) => {
        this.loading = false;
        this.exibirMensagemErro(err)
      }
    })
  }

  excluir(pspId: number) {
    this.confirmationService.confirm({
      message: "Tem certeza que deseja excluir?",
      header: "Confirmação",
      acceptLabel: "Sim",
      rejectLabel: "Não",
      icon: "pi pi-info-circle",
      accept: () => {
        this.pspConfiguracaoEmpresaService.excluir(pspId).subscribe({
          next: () => {
            this.exibirMensagemSucesso();
            this.listar();
          },
          error: (err: any) => {
            this.exibirMensagemErro(err);
          }
        }

        );
      },
    });
  }


  buscar(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, "contains");
  }

  limpar(table: Table) {
    table.clear();
    this.filter.nativeElement.value = "";
  }

}
